import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-yoga-al',
	options: {
		userTags: ['tai_chi_yoga'],
	},
	landing: {
		ids: ['loader-tai-chi-yoga-m', 'age-tai-chi-yoga-m-al'],
		route: {
			path: '/tai-chi-yoga-m-al',
			name: 'male-tai-chi-yoga-funnel-al',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-yoga-al',
		route: {
			path: '/tai-chi-yoga-m-al/ob/:page(.*)?',
			name: 'activity-male-tai-chi-yoga-al',
		},
		slug: 'activity-male-tai-chi-yoga-al',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-yoga-m-al',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
}

export default appAreaConfig
